/**
 * Мелкие проверки wire-ответов службы графика. Тип TypeScript ответ не проверяет (D-056): неожиданная форма — это ошибка
 * `invalid-response`, а не пустая сетка. Тексты сообщений идут в `TransportError.message` для отчёта.
 */
export function fail(message: string): never {
  throw new Error(message)
}

export function record(value: unknown, field: string): Record<string, unknown> {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) fail(`${field} — не объект`)
  return value as Record<string, unknown>
}

export function text(value: unknown, field: string): string {
  return typeof value === 'string' && value.trim() !== '' ? value : fail(`поле ${field} — не строка`)
}

/** Строка, которой может не быть: `null`/отсутствие — `null`. */
export function optionalText(value: unknown, field: string): string | null {
  if (value === null || value === undefined) return null
  return typeof value === 'string' ? value : fail(`поле ${field} — не строка`)
}

export function flag(value: unknown, field: string): boolean {
  return typeof value === 'boolean' ? value : fail(`поле ${field} — не логическое`)
}

export function integer(value: unknown, field: string): number {
  return typeof value === 'number' && Number.isInteger(value) ? value : fail(`поле ${field} — не целое число`)
}

/** Одно из известных значений: неизвестное — ошибка разбора, а не молчаливая подмена. */
export function oneOf<T extends string>(value: unknown, allowed: readonly T[], field: string): T {
  return allowed.find((item) => item === value) ?? fail(`поле ${field} — неизвестное значение`)
}

export function list<T>(value: unknown, field: string, item: (raw: unknown, name: string) => T): T[] {
  if (!Array.isArray(value)) fail(`поле ${field} — не массив`)
  return value.map((entry: unknown, index) => item(entry, `${field}[${index}]`))
}

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/

/** Календарный день `ГГГГ-ММ-ДД` без часового пояса. */
export function isoDay(value: unknown, field: string): string {
  return typeof value === 'string' && ISO_DAY.test(value) ? value : fail(`поле ${field} — не дата ГГГГ-ММ-ДД`)
}
